export interface WatchlistCaseRow {
    id: number;
    no: string;
    cifId: string;
    accountNo: string;
    entityName: string;
    hitDate: string;
    ruleId: string;
    branch: string;
    osDays: number;
    assignee: string;
    status: string;
    action: string;
    isMyCase: boolean;
}

export interface ActivityModel {
    type: 'activity' | 'comment';
    actor: string;
    action: string;
    timestamp: string;
    detail?: string;
}

export interface FileModel {
    kind: 'jpg' | 'pdf' | 'doc';
    uploadedBy: string;
    uploadedDate: string;
    fileName: string;
}

export const WATCHLIST_FIXTURES: WatchlistCaseRow[] = [
    {
        id: 1,
        no: 'WL-0001',
        cifId: 'CIF-100234',
        accountNo: 'ACC-500011',
        entityName: 'John Doe',
        hitDate: '2024-01-15',
        ruleId: 'RULE-OFAC-01',
        branch: 'Head Office',
        osDays: 5,
        assignee: 'analyst.kim',
        status: 'pending',
        action: 'view',
        isMyCase: true
    },
    {
        id: 2,
        no: 'WL-0002',
        cifId: 'CIF-100987',
        accountNo: 'ACC-500042',
        entityName: 'Jane Smith',
        hitDate: '2024-01-16',
        ruleId: 'RULE-UN-07',
        branch: 'Phnom Penh',
        osDays: 3,
        assignee: 'analyst.kim',
        status: 'open',
        action: 'view',
        isMyCase: true
    },
    {
        id: 3,
        no: 'WL-0003',
        cifId: 'CIF-102001',
        accountNo: 'ACC-500204',
        entityName: 'David Lee',
        hitDate: '2024-01-10',
        ruleId: 'RULE-UN-07',
        branch: 'Phnom Penh',
        osDays: 15,
        assignee: 'analyst.sok',
        status: 'closed',
        action: 'view',
        isMyCase: false
    },
    {
        id: 4,
        no: 'WL-0004',
        cifId: 'CIF-102334',
        accountNo: 'ACC-500251',
        entityName: 'Emma Davis',
        hitDate: '2024-01-08',
        ruleId: 'RULE-EU-03',
        branch: 'Head Office',
        osDays: 20,
        assignee: 'analyst.sok',
        status: 'closed',
        action: 'view',
        isMyCase: false
    },
    {
        id: 5,
        no: 'WL-0005',
        cifId: 'CIF-104566',
        accountNo: 'ACC-500505',
        entityName: 'William Anderson',
        hitDate: '2024-01-28',
        ruleId: 'RULE-EU-03',
        branch: 'Head Office',
        osDays: 30,
        assignee: 'analyst.sok',
        status: 'closed',
        action: 'view',
        isMyCase: false
    }
];

export const ALL_ACTIVITY_FIXTURES: ActivityModel[] = [
    { type: 'activity', actor: 'Lanh Kongkosol', action: 'updated the case status to', timestamp: '2023-06-11T12:30:00' },
    { type: 'activity', actor: 'Dara Meas', action: 'assigned the case to', timestamp: '2023-06-10T09:15:00' },
    { type: 'activity', actor: 'Sokha Chan', action: 'updated the case status to', timestamp: '2023-06-08T16:45:00' },
    { type: 'comment', actor: 'Sokha Chan', action: 'added a comment', timestamp: '2023-06-08T14:05:00', detail: 'Please review the attached red flag report before approval.' },
    { type: 'comment', actor: 'Dara Meas', action: 'added a comment', timestamp: '2023-06-06T10:20:00', detail: 'Customer provided additional KYC documents for verification.' }
];

export const FILE_FIXTURES: FileModel[] = [
    { kind: 'jpg', uploadedBy: 'Heng Sok', uploadedDate: '2024-10-28', fileName: 'ic_jpg.png' },
    { kind: 'pdf', uploadedBy: 'Heng Sok', uploadedDate: '2024-10-28', fileName: 'ic_pdf.png' },
    { kind: 'doc', uploadedBy: 'Dara Meas', uploadedDate: '2024-10-29', fileName: 'ic_doc.png' }
];
